import PrivateRoute from 'utils/privateRoute';
import CrossFlowNavigatorPage from '../components/CrossFlowNavigator/CrossFlowNavigatorPage';

const CrossFlowNavigatorRoutes = [
	{
		key: 'crossflow_navigator',
		route: '/dataOps/crossFlowNavigator',
		component: (
			<PrivateRoute
				Component={CrossFlowNavigatorPage}
				restrictedRoles={['Data Operations Admin', 'Data Operations User', 'D&AI Executive User', 'Program Executive']}
			/>
		)
	},
	{
		key: 'crossflow_navigator_tab',
		route: '/dataOps/crossFlowNavigator/:tab',
		component: (
			<PrivateRoute
				Component={CrossFlowNavigatorPage}
				restrictedRoles={['Data Operations Admin', 'Data Operations User', 'D&AI Executive User', 'Program Executive']}
			/>
		)
	},
];

export default CrossFlowNavigatorRoutes;